import { Box, CheckBox, Text } from '@jfs/ui-new'
import { getCommaFormatedVal, getFormatedMoney, shouldShowTooltip } from './../../util/util'
import { TooltipView } from './TooltipView'

export const SegmentedByListitem = ({
  item,
  updateSegmentedByData,
  showByPercentage,
  getGraphPrefrences,
  index,
}: any) => {
  console.log('SegmentedByListitem', index)

  const updateChartAxis = (isChecked: boolean) => {
    updateSegmentedByData(item.segment, isChecked)
  }
  const isCount = getGraphPrefrences().transactions === 'Count'
  const formatedMoney = getFormatedMoney(Number(item.value ?? '0'), isCount)
  return (
    <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} pv={16}>
      <Box flexDirection={'row'} alignItems={'center'}>
        <CheckBox checked={item.checked} onChecked={updateChartAxis} iconSize={16} fontSize={16} color={'BLUE'}/>
        <Box marginHorizontal={8} height={8} width={8} borderRadius={4} bg={item.color} />
        <Text type={'h4'} fontFamily={'jiotype-medium'} fontSize={12} color={'PRIMARY_GREY'}>
          {item.segment.toUpperCase()}
        </Text>
      </Box>
      <Box flexDirection="row" justifyContent="center" alignItems="center">
        <Text
          type={'h4'}
          fontFamily={'jiotype-bold'}
          fontSize={12}
          color={'BLACK'}
          testID={`segmentedListItemAmount${index}`}>
          {showByPercentage ? item.percentage : formatedMoney}
        </Text>
        {formatedMoney && shouldShowTooltip(Number(item.value ?? '0')) && !showByPercentage && (
          <TooltipView value={getCommaFormatedVal(Number(item.value), isCount)} />
        )}
      </Box>
    </Box>
  )
}
